// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-adobe-photoshop"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L21 3L21 21L3 21L3 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 3L21 3L21 21L3 21L3 3Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 17L7 12M7 12L7 7L9.5 7C10.8807 7 12 8.11929 12 9.5C12 10.8807 10.8807 12 9.5 12H7ZM17 11H15.9528C15.1505 11 14.5 11.6505 14.5 12.4528C14.5 13.0782 14.9002 13.6334 15.4934 13.8311L16.5066 14.1689C17.0998 14.3666 17.5 14.9218 17.5 15.5472C17.5 16.3495 16.8495 17 16.0472 17H14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoAdobePhotoshopIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-adobe-photoshop',
    ref,
    icon: element,
  },
));

LogoAdobePhotoshopIcon.displayName = 'LogoAdobePhotoshopIcon';

export default LogoAdobePhotoshopIcon;
